import { entities } from "sbtech-sports-data-api-client";
import { eBranches } from "sb-resp-lib";
import { Scores } from "./TeamScoreModel";
import { TeamTennisScoreParser } from "./TeamTennisScoreParser";

export class TeamScoreParser {
    private static _instance: TeamScoreParser;

    private constructor() { }

    public static get instance(): TeamScoreParser {
        if (!TeamScoreParser._instance) {
            TeamScoreParser._instance = new TeamScoreParser();
        }
        return TeamScoreParser._instance;
    }

    public parse(sportEvent: entities.SportEvent, sportId: string): Scores {
        if (Number(sportId) === eBranches.Tennis) {
            return TeamTennisScoreParser.instance.parse(sportEvent);
        }

        return this.defaultParse(sportEvent);
    }

    private defaultParse(sportEvent: entities.SportEvent): Scores {
        if (!sportEvent.score) {
            return { Home: undefined, Away: undefined };
        }

        return sportEvent.isTeamSwap
            ? { Home: sportEvent.score.awayScore, Away: sportEvent.score.homeScore }
            : { Home: sportEvent.score.homeScore, Away: sportEvent.score.awayScore };
    }
};